import { createRoute } from '@tanstack/react-router';

import { RootRoute } from '$/routes/RootRoute';

export const LicenseRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/license',
}).lazy(() => import('./LicenseRoute.lazy').then((d) => d.Route));
